import moment from 'moment';

// formVehicle constants
export const PLAQUESOPTIONS = [
  {'key': 0, 'value': 0, 'text': '0'},
  {'key': 1, 'value': 1, 'text': '1'},
  {'key': 2, 'value': 2, 'text': '2'},
  {'key': 3, 'value': 3, 'text': '3'},
  {'key': 4, 'value': 4, 'text': '4'},
  {'key': 5, 'value': 5, 'text': '5'},
  {'key': 6, 'value': 6, 'text': '6'},
  {'key': 7, 'value': 7, 'text': '7'},
  {'key': 8, 'value': 8, 'text': '8'},
  {'key': 9, 'value': 9, 'text': '9'},
];
export const ACTUALYEAR = moment().year();
export const MAXYEARS = 5;

// state of the reques options
export const STATE_OPTIONS_CPOS = [
  {'key': 0, 'value': 'APROBADO', 'text': 'APROBADO'},
  {'key': 1, 'value': 'RECHAZADO', 'text': 'RECHAZADO'},
  {'key': 2, 'value': 'ENVIADO', 'text': 'ENVIADO'},
  {'key': 3, 'value': 'INGRESADO', 'text': 'INGRESADO'},
  {'key': 4, 'value': 'VENDIDO', 'text': 'VENDIDO'},
];

export const STATE_OPTIONS_WARRANTY = [
  {'key': 0, 'value': 'APROBADO', 'text': 'APROBADO'},
  {'key': 1, 'value': 'RECHAZADO', 'text': 'RECHAZADO'},
  {'key': 2, 'value': 'ENVIADO', 'text': 'ENVIADO'},
  {'key': 3, 'value': 'INGRESADO', 'text': 'INGRESADO'},
];

// file upload contansts
export const MAXFILESIZE = '3MB';
export const MAXFILESIZEKB = '5000000';
export const MAXTOTALFILESIZE = '20MB';
export const FILE_NAMES = ['side', 'frontal', 'back', 'inner', 'board', 'document', 'others'];
export const HEIGHT_IMAGE = 150;

// errors messages
export const ERROR_MESSAGE_ACCESORIES = 'El accesorio ya se encuentra en la lista';
export const ERROR_MESSAGE_FORM = 'Complete todos los campos de la sección 2 por favor';
export const ERROR_MESSAGE_KM = 'El rango máximo es hasta  100,000 km';
export const ERROR_MESSAGE_DATE = 'El vehículo debe tener máximo 5 años ';
export const ERROR_WARRANTY = 'Por favor ingrese los campos de la sección 2';
export const ERROR_STATUS = 'Por favor debe seleccionar el estado de vehículo';
export const ERROR_MESSAGE_FILES = `Es necesario cargar el documento en los 150pts de la 
sección 3 cuando el kilometraje es mayor de 1000k`;
export const VALIDATION_KM = 100000;
export const VALIDATION_YEARS = 4;
export const DATEFORMAT = 'DD-MM-YYYY';


export const CITIES = [
  {'value': 'QUITO', 'key': 'QUITO', 'text': 'QUITO'},
  {'value': 'GUAYAQUIL', 'key': 'GUAYAQUIL', 'text': 'GUAYAQUIL'},
  {'value': 'CUENCA', 'key': 'CUENCA', 'text': 'CUENCA'},
];

export const VEHICLE_STATE = [
  {'value': '', 'key': '', 'text': ''},
  {'value': 'NUEVO', 'key': 'NUEVO', 'text': 'NUEVO'},
  {'value': 'VENDIDO', 'key': 'VENDIDO', 'text': 'VENDIDO'},
];
